import type { FunctionMetadataTypes, ResponseReadAll } from "epsm-api-types";
import { Converter } from "epsm-api-types/converter";
import type {
	ScorerRequestParams,
	ScorerSingleEntry,
} from "epsm-api-types/models";
import { BaseService } from "@/services/BaseService";
import { HttpClient, type IHttpClient } from "@/services/HttpClient";

export class ScorerService extends BaseService<
	ScorerSingleEntry,
	ScorerSingleEntry
> {
	private constructor(private httpClient: IHttpClient) {
		super(new Converter());
	}

	private static instance: ScorerService;

	static create() {
		if (!ScorerService.instance) {
			ScorerService.instance = new ScorerService(HttpClient.create());
		}
		return ScorerService.instance;
	}

	async getData(
		params: ScorerRequestParams & FunctionMetadataTypes,
	): Promise<ResponseReadAll<ScorerSingleEntry>> {
		const bodyParams = this.getBodyParams(params);
		const response = await this.httpClient.post<
			ResponseReadAll<ScorerSingleEntry>
		>("/scorer", {
			...bodyParams,
			params: {
				...bodyParams.params,
				columns: params.columns,
			},
		});

		return this.getResponseReadAll(response, params.types);
	}
}
